import { LedgerHead } from "./mapping-transaction-model";
import { Purpose, Txncategory } from "./tallyentry-api-model";

export class PurposeLedgerMapHeader {
    accountsPurposeLedgerId: number;
    txncategory = new Txncategory();
    purpose = new Purpose();
    modeOfPayment?: string;
    approvalStatus?: boolean;
    ledgerHeadList?: LedgerHead[] = [];
  
    constructor(init?: Partial<PurposeLedgerMapHeader>) {
      if (init) {
        Object.assign(this, init);
      }
    }
}